export enum CitationType {
    Document,
    Image,
  }
  